'use client'

import React from 'react'
import { Message } from '@locmod/intl'
import { Switch as HeadlessSwitch } from '@headlessui/react'
import { useLive } from '@azuro-org/sdk'
import cx from 'classnames'

import { Icon } from 'components/ui'

import messages from './messages'

const Switch = ({ isLive, changeLive }) => {
  return (
    <HeadlessSwitch
      checked={isLive}
      onChange={changeLive}
      className="relative flex h-5 w-9 cursor-pointer rounded-sm bg-accent-grey-900 px-1 items-center transition-colors duration-200 ease-in-out  border border-accent-grey-950 ui-checked:border-accent-red-500 ui-checked:bg-accent-red-500"
    >
      <span
        aria-hidden="true"
        className="pointer-events-none inline-block size-3 translate-x-0 rounded-full bg-accent-grey-200 transition duration-200 ease-in-out ui-checked:translate-x-4 ui-checked:bg-black"
      />
    </HeadlessSwitch>
  )
}

const LiveSwitcher: React.FC<{ className?: string }> = ({ className }) => {
  const { isLive, changeLive } = useLive()

  return (
    <div
      className={cx(
        'border rounded-sm bg-gradient-to-r to-accent-red-500/0 py-2 pl-4 pr-2 flex items-center justify-between border-accent-red-500/20 from-accent-red-500/10 bg-clip-padding',
        // {
        //   'border-brand-light-500  from-[#F0C46E]/75': !isLive,
        //   'border-accent-red-500  from-accent-red-500/75': isLive,
        // },
        className
      )}
    >
      <div className="flex items-center text-accent-red-500">
        <Icon className="size-4 mr-2" name="interface/live" />
        <Message
          className="text-caption-12 font-semibold"
          value={messages.title}
        />
      </div>
      <Switch isLive={isLive} changeLive={changeLive} />
    </div>
  )
}

export default LiveSwitcher
